import React from 'react';
import { styled } from '@mui/material/styles';
import L from 'leaflet';
import { Circle, Marker, Popup, Tooltip, useMap } from "react-leaflet";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import { LatLng } from "leaflet/dist/leaflet-src.esm";
import { IconButton } from "@mui/material";
import { DeleteForever } from "@mui/icons-material";
import './Geoloc.css';
import IconLocation from '../../assets/my_location-24px.svg';
import { useTranslation } from "react-i18next";
const PREFIX = 'Geoloc';

const classes = {
  exparienceImageUrl: `${PREFIX}-exparienceImageUrl`
};

const Root = styled('div')((
  {
    theme
  }
) => ({

  [`& .${classes.exparienceImageUrl}`]: {
    position: 'absolute',
    top: '50%',
    left: '0%',
    transform: 'translate(0, -50%)',
    width: '100px',
    objectFit: 'contain',
    marginBottom: '1rem'
  }
}));

const searchControl = new GeoSearchControl({
  provider: new OpenStreetMapProvider(),
  style: 'bar',
  position: 'topleft',
  showMarker: true,
  maxMarker: 1,
  autoClose: true,
  autoComplete: true,
  retainZoomLevel: true,
  maxSuggestions: 5,
  keepResult: true,
  marker: {
    icon: L.icon({
      iconUrl: IconLocation,
      iconSize: [24, 24], // size of the icon
      iconAnchor: [12, 12], // point of the icon which will correspond to marker's location
    }),
    cat: 'roos',
    draggable: true,
  },
  resultFormat: function (t) {
    return "" + t.result.label;
  },
  updateMap: !0

});

const Geoloc = (props) => {
  const myLocationIcon = L.icon({
    iconUrl: IconLocation,
    iconSize: [24, 24], // size of the icon
    iconAnchor: [12, 12], // point of the icon which will correspond to marker's location
  });


  const { t } = useTranslation();

  const map = useMap();

  const resetMyPosition = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      props.setMyPosition(new LatLng(position.coords.latitude, position.coords.longitude));
    });
    props.setMarkerToFlyTo(null);
  }

  React.useEffect(() => {
    if (!props.visualize) {
      map.addControl(searchControl);
    }
    map.on('moveend', function () {
      resetMyPosition();
    })
  }, [])

  function GeoSearch(props) {

    const onSubmitCustom = (e) => {
      if (e && e.data) {
        const marker = {
          position: new LatLng(e.data.y, e.data.x),
          title: e.data.label,
          radius: 1000,
          visible: false,
          free: false,
          controlDate: false,
          startDate: null,
          endDate: null,
        };
        map.flyTo(marker.position, map.getZoom())
        props.addMarker(marker, map);
      }
    }
    searchControl.onSubmit = onSubmitCustom;

    return null;
  }


  React.useEffect(() => {
    if (props.markerToFlyTo) {
      map.flyTo(props.markerToFlyTo, props.dashboardMap ? map.getZoom() > 7 ? map.getZoom() : 7 : map.getZoom());
    }
  }, [props.markerToFlyTo]);

  return (
    <Root>
      <GeoSearch addMarker={props.addMarker} style={{ position: 'absolute', left: '50%', display: 'block' }} />
      {!props.dashboardMap &&
        <Marker
          position={props.errorMyPosition ? [47.2180499461086, -1.5576933846545309] : props.myPosition}
          icon={myLocationIcon}
        >
          <Tooltip permanent direction="bottom" offset={[0, 12]} opacity={1}>
            {props.errorMyPosition ? t('positions.ads') : t('positions.my')}
          </Tooltip>
        </Marker>
      }
      {props.markers.map((m, idx) => {
        return (
          <Circle
            center={m.position}
            key={`marker-${m.title}-${m.radius}-${idx}`}
            radius={m.radius}
            color="#B59A4F"
            eventHandlers={props.dashboardMap ? { click: e => map.flyTo(m.position, map.getZoom() > 7 ? map.getZoom() : 7)} : {}}
          >
            <Popup key={`popup-${m.title}-${idx}`} >
              <h5>{m.title}</h5>
              {props.dashboardMap ?
                <img src={m.imageUrl} alt="exparience logo" className={classes.exparienceImageUrl} />
                :
                <div className="popup-icon-delete">
                  <IconButton onClick={() => props.removeMarker(idx)} size="large"><DeleteForever /></IconButton>
                </div>
              }
            </Popup>
          </Circle>
        );
      })
      }
    </Root>
  );
}

export default Geoloc;
